import React, { Component } from 'react'

export default class People extends Component {
  render () {

    const { name, position, image_redonda, signature } = this.props;

    return (
    	<div className="intro-people">
        <img src={image_redonda} alt="LJRamos" className="img-profile"/>
        <h1>{name}</h1>
        <h2>{position}</h2>
        <img src={signature} alt="LJRamos" className="img-signature" />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/PageCompany/Components/People.component.js